import React from 'react';

import StatusContext from '../../../contexts/StatusContext'

import "./waitonresponse.css"

export const WaitonResponse = () => {

  let {
    focusRef,
    waitonResponse,
  } = React.useContext(StatusContext);

  
  return (
       
    <div >
      <br></br>
  
    {
    
        (waitonResponse) &&
        <>
          <span  style={{margin:'10px',  color:'maroon', marginBottom:'30px'}}>{waitonResponse}</span>
    
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
          <br ref = {focusRef}></br>
        </>
    }
    </div>
  );
  

 
};
